exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#div_service[data-v-e4437338]{margin:15px auto;padding-left:10px;border-left:2px solid #eee}.p_keytag[data-v-e4437338]{font-weight:700;font-size:15px}.li_role[data-v-e4437338]{font-size:14px}.li_award[data-v-e4437338]{font-size:16px;font-weight:700;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4437338","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/service.vue
// module id = 307
// module chunks = 0